import { clsx } from 'clsx';
import { initials } from '../../lib/format';

const palette = [
  'bg-sky-100 text-sky-700 dark:bg-sky-500/15 dark:text-sky-300',
  'bg-violet-100 text-violet-700 dark:bg-violet-500/15 dark:text-violet-300',
  'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300',
  'bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300',
  'bg-rose-100 text-rose-700 dark:bg-rose-500/15 dark:text-rose-300',
  'bg-indigo-100 text-indigo-700 dark:bg-indigo-500/15 dark:text-indigo-300',
];

export function Avatar({
  name,
  size = 'md',
  src,
  className,
}: {
  name?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  src?: string;
  className?: string;
}) {
  const sizes = {
    xs: 'size-6 text-[10px]',
    sm: 'size-8 text-[12px]',
    md: 'size-10 text-[14px]',
    lg: 'size-14 text-[20px]',
  } as const;
  const color = palette[(name?.charCodeAt(0) ?? 0) % palette.length];

  if (src) {
    return (
      <img
        src={src}
        alt={name ?? ''}
        className={clsx(sizes[size], 'rounded-none object-cover', className)}
      />
    );
  }
  return (
    <div
      className={clsx(
        sizes[size],
        'grid shrink-0 place-items-center rounded-none font-bold',
        color,
        className,
      )}
    >
      {initials(name)}
    </div>
  );
}
